import { defineSlotRecipe } from '@chakra-ui/react'
import { tagAnatomy } from '@chakra-ui/react/anatomy'

// base styles
const container = {
    border: '1px solid',
    borderRadius: '8px',
    cursor: 'pointer',
    padding: '6px 12px',
    fontSize: '14px',
    _light: {
        borderColor: 'dark.700',
        color: 'dark.700',
        _hover: {
            background: 'rgba(84, 79, 64, 0.08)',
        },
    },
    _dark: {
        borderColor: 'white',
        color: 'white',
    },
}

export const tagSlotRecipe = defineSlotRecipe({
    slots: tagAnatomy.keys(),
    variants: {
        variant: {
            'gsk-tag': {
                root: container,
            },
            'gsk-tag-selected': {
                root: {
                    ...container,
                    _light: {
                        ...container._light,
                        background: 'accent.100',
                        borderColor: 'accent.100',
                        _hover: {
                            background: 'accent.100',
                        },
                    },
                    _dark: {
                        ...container._dark,
                        background: 'accent.1000',
                        borderColor: 'accent.1000',
                        _hover: {
                            background: 'accent.1000',
                        },
                    },
                },
            },
            'multi-select': {
                root: {
                    background: 'rgb(242, 241, 240)',
                    borderRadius: '16px',
                    color: 'var(--chakra-colors-dark-700)',
                    padding: '4px 12px',
                    opacity: '1',
                    _dark: {
                        background: '#202020',
                        borderColor: '#202020',
                        color: 'var(--chakra-colors-white)',
                    },
                },
                closeTrigger: {
                    color: 'var(--chakra-colors-dark-700)',
                    opacity: '1',
                    _dark: {
                        color: 'var(--chakra-colors-white)',
                    },
                },
                endElement: {
                    width: '16px',
                    height: '16px',
                },
                label: {
                    fontSize: '14px',
                    fontWeight: '500',
                    lineHeight: '20px',
                },
            },
        },
    },
})
